"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hwbToRgb = hwbToRgb;
exports.rgbToHwb = rgbToHwb;
var hsv_1 = require("./hsv");
/**
 * Converts HWB values to RGB color space.
 * @param {HWB} hwb - The HWB color to convert.
 * @returns {RGB} The color in RGB space.
 */
function hwbToRgb(hwb) {
    var h = hwb.h, w = hwb.w, b = hwb.b;
    // Handle black and white cases
    if (w + b >= 100) {
        var gray = Math.round(w / (w + b) * 255);
        return { r: gray, g: gray, b: gray };
    }
    var s = 100 - (w / (100 - b)) * 100;
    var v = 100 - b;
    return (0, hsv_1.hsvToRgb)({ h: h, s: s, v: v });
}
/**
 * Converts RGB values to HWB color space.
 * @param {RGB} rgb - The RGB color to convert.
 * @returns {HWB} The color in HWB space.
 */
function rgbToHwb(rgb) {
    var hsv = (0, hsv_1.rgbToHsv)(rgb);
    var w = (1 - hsv.s / 100) * hsv.v / 100 * 100;
    var b = 100 - hsv.v;
    return { h: hsv.h, w: w, b: b };
}
